import { render, staticRenderFns } from "./radioButtonSimples.vue?vue&type=template&id=00fc3d5a&scoped=true&"
import script from "./radioButtonSimples.vue?vue&type=script&lang=js&"
export * from "./radioButtonSimples.vue?vue&type=script&lang=js&"
import style0 from "./radioButtonSimples.vue?vue&type=style&index=0&id=00fc3d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc3d5a",
  null
  
)

export default component.exports